import { render, staticRenderFns } from "./examinationmanage.vue?vue&type=template&id=9cbfaeda&scoped=true"
import script from "./examinationmanage.vue?vue&type=script&lang=js"
export * from "./examinationmanage.vue?vue&type=script&lang=js"
import style0 from "./examinationmanage.vue?vue&type=style&index=0&id=9cbfaeda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbfaeda",
  null
  
)

export default component.exports